import React from 'react';
import { Editor } from "../../../blocks/editor-00/editor";
import { SerializedEditorState } from "lexical";

interface NoteEditorProps {
  sessionOverview: SerializedEditorState | null;
  onEditorChange: (serializedState: SerializedEditorState) => void;
  isOpen: boolean;
  isDraftPopulated: boolean;
  currentNoteId: number | null;
}

const NoteEditor: React.FC<NoteEditorProps> = ({
  sessionOverview,
  onEditorChange,
  isOpen,
  isDraftPopulated,
  currentNoteId
}) => {
  return (
    <div className="mt-3">
      <label htmlFor="session-overview-editor" className="graySmallText">
        Session Overview
      </label>

      <div className="" id="session-overview-editor">
        <Editor
          key={`editor-${isOpen}-${isDraftPopulated}-${currentNoteId || 'new'}`}
          editorSerializedState={sessionOverview || undefined}
          onSerializedChange={onEditorChange}
        />
      </div>
    </div>
  );
};

export default NoteEditor;
